<template>
<div>
    <Breadcrumbs main="Admin" title="Initiatives" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">
                                <div class="d-flex flex-column flex-xl-row " style="gap: 10px;">
                                    <b-input-group class="datatable-btn">
                                        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                        <b-input-group-append>
                                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </div>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="items" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(date)="row">
                                        {{row.value.split('T')[0]}}
                                    </template>

                                    <template #cell(title)="row">
                                        <div style="min-width: 150px; max-width: 250px;">{{ row.value }}</div>
                                    </template>

                                    <template #cell(description)="row">
                                        <div style="max-width: 250px;" v-html="truncateText(row.item.description, 150)"></div>
                                    </template>

                                    <template #cell(image)="row">
                                        <img style="max-height: 80px; border-radius: 6px;" :src="row.item.image" alt="">
                                    </template>

                                    <template #cell(changemaker)="row">
                                        <div style="min-width: 150px; max-width: 230px;">
                                            <h7>{{ row.item.changemaker?.name }}</h7>
                                        </div>
                                    </template>

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteInitiative(data.item.slug)" title="Delete"></feather>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this Initiative?</div>
    </b-modal>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import {
    myHost
} from '../../_helpers/host'

export default {

    data() {
        return {
            host: myHost.host,
            tablefields: [
                {
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'title',
                    label: 'Title',
                    sortable: true
                },
                {
                    key: 'description',
                    label: 'Description',
                    sortable: true
                },
                {
                    key: 'location',
                    label: 'Location',
                    sortable: true
                },
                {
                    key: 'date',
                    label: 'Date',
                    sortable: true
                },
                {
                    key: 'image',
                    label: 'Image',
                    sortable: true
                },
                {
                    key: 'changemaker',
                    label: 'Changemaker',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: true
                } 
            ],
            initiative_view: null,
            filter: null,
            delete_value: null,

            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15]
        };
    },

    computed: {
        ...mapState({
            items: state => state.initiative.initiatives,
            loading: state => state.initiative.initiativeLoading,
            error: state => state.initiative.initiativeError
        }),

        sortOptions() {
            return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
        }
    },

    mounted() {
        this.$store.dispatch('initiative/fetchInitiativeList').then(() => {
            this.totalRows = this.items.length;
        });
    },

    methods: {
        truncateText(text, maxLength) {
            if (text.length > maxLength) {
                return text.substring(0, maxLength) + '...';
            } else {
                return text;
            }
        },

        resetModal() {
            this.selectedStatus = '';
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        updateToggle(id) {
            this.$store.dispatch('initiative/updateStatusToggle', {
                initiative_id: id,
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: 'Success!',
                        text: response.response,
                        icon: 'success'
                    });
                } else {
                    Swal.fire({
                        title: 'Error!',
                        text: response.response,
                        icon: 'error'
                    });
                }
            });
        },

        viewInitiative(initiative) {
            this.initiative_view = initiative
        },

        deleteInitiative(id) {
            this.delete_value = id
        },

        handleDeleteOk() {
            this.$store.dispatch('initiative/deleteInitiative', {
                delete_value: this.delete_value,
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: 'Success!',
                        text: response.response,
                        icon: 'success'
                    });
                    this.delete_value = null
                } else {
                    Swal.fire({
                        title: 'Error!',
                        text: response.response,
                        icon: 'error'
                    });
                }
            });
        }
    }
};
</script>

<style scoped>
.header-mobile {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

@media screen and (max-width: 460px) {
    .header-mobile {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: start;
    }
}
</style>
